import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserService } from './user.service';
import { Constant } from '../constants/constant';
import { EcryptServiceService } from './ecrypt-service.service';
import { catchError, map, tap } from 'rxjs/operators';
@Injectable({
	providedIn: 'root'
})
export class ConfigServiceService {

	url = environment.serverAPI + '/api/catalog/siteData/new';

	url1 = environment.serverAPI4 + '/api/medical/delivery/site/data';

	url2 = environment.serverAPI4 + '/api/ig/medical/delivery/site/data';

	url6 = environment.serverAPI4 + '/' + 'api/product';

	url7 = environment.serverAPI4 + '/' + 'api/ig/product';
	constructor(private http: HttpClient,
		private ecryptServiceService: EcryptServiceService,
		private userService: UserService) { }


	public responseCacheConfig = new Map();



	getConfigData(): Observable<any> {

		const encryptedData =
			localStorage.getItem(Constant.ENCRYPT_KEY_CONFIG_NEW) ??
			localStorage.getItem(Constant.ENCRYPT_KEY_CONFIG);

		if (encryptedData) {
			try {
				const decrypted = this.ecryptServiceService.decryptionAES(encryptedData);
				const data = JSON.parse(decrypted);
				return of(data); // 👈 wrap sync data in Observable
			} catch (e) {
				console.error('Decryption failed', e);
				return throwError(() => e);
			}
		}

		return this.http.get<any>(this.url).pipe(
			map(response => {
				let configData = response;

				if (response?.encryptedText) {
					localStorage.setItem(Constant.ENCRYPT_KEY_CONFIG_NEW, response.encryptedText);
					const decrypted = this.ecryptServiceService.decryptionAES(response.encryptedText);
					configData = JSON.parse(decrypted);
				} else {
					const encrypted = this.ecryptServiceService.encryptionAES(JSON.stringify(configData));
					localStorage.setItem(Constant.ENCRYPT_KEY_CONFIG, encrypted);
				}

				return configData;
			})
		);
	}


	public medicalDeliveryOption(): Observable<any> {
		let authourized = this.userService.getAuthenticatedUser();
		let guestLoginEnabled = localStorage.getItem(Constant['GUEST_LOGIN'])
		if (authourized == null || guestLoginEnabled == "1") {
			return this.http.get(`${this.url2}`);

		} else {
			return this.http.get(`${this.url1}`);
		}
	}

	deleteImage(data: any): Observable<Object> {
		let authourized = this.userService.getAuthenticatedUser();
		let guestLoginEnabled = localStorage.getItem(Constant['GUEST_LOGIN'])
		if (authourized == null || guestLoginEnabled == "1") {
			return this.http.post(`${this.url7}/deleteImage`, data);
		} else {
			return this.http.post(`${this.url6}/deleteImage`, data);
		}

	}
}
